import React, { useContext, useState } from 'react';
import classnames from 'classnames';
import * as Icon from 'react-feather';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button, NavItem, NavLink } from 'reactstrap';
import Autocomplete from '../components/@vuexy/autoComplete/AutoCompleteComponent';
import {
  setIsCallWaiterModalOpen,
  setIsListOrdersModalOpen,
  setIsMoreSettingsModalOpen,
  setIsPickupStatusModalOpen,
  setIsSelfServiceTableSelectionModalOpen,
  setSelfServiceTableSelectionModalData,
  setIsSetFiltersModalOpen,
} from '../redux/modal/modal.actions';
import PropTypes from 'prop-types';
import { setShowAppOverlay } from '../redux/customizer/customizer.actions';
import TagManager from 'react-gtm-module/dist/TagManager';
import { getBrowserLocale, isAdminMode } from '../utility/util/util.service';
import {
  fetchOnAuthenticated,
  fetchOrders,
  setFoodAllergensFilter,
  setFoodIngredientsFilter,
  setFoodPreferencesFilter,
} from '../redux/me/me.actions';
import { SocketContext } from '../context/socket.context';
import { createGuest } from '../utility/sb-api/sb-api.service';
import { IntlContext } from '../context/intl.context';
import { useHistory, useLocation } from 'react-router-dom';
import { setCart, setCheckout, setOrder } from '../redux/store/store.actions';

const NavbarUser = ({
  me,
  store,
  menuEntriesData,
  pickupOrder,
  isSearchOpen,
  menuEntries,
  kiosk,
  table,
  showCancelOrderButton,

  setIsListOrdersModalOpen,
  isSetFiltersModalOpen,
  setIsSetFiltersModalOpen,
  foodAllergensFilter,
  foodPreferencesFilter,
  foodIngredientsFilter,
  auth0,
  /*setIsPickupStatusModalOpen,*/
  setIsMoreSettingsModalOpen,
  setShowAppOverlay,
  setIsSearchOpen,
  setIsCallWaiterModalOpen,
  setFoodAllergensFilter,
  setFoodIngredientsFilter,
  setFoodPreferencesFilter,
  setCheckout,
  setCart,
  setOrder,
  setIsSelfServiceTableSelectionModalOpen,
  setSelfServiceTableSelectionModalData,
}) => {
  const [suggestions, setSuggestions] = useState([]);

  const areAnyFiltersSet =
    foodAllergensFilter?.length > 0 ||
    foodPreferencesFilter?.length > 0 ||
    foodIngredientsFilter?.length > 0;

  const filterUniqueObjects = (array, property) => {
    const seen = new Set();
    return array.filter((obj) => {
      const value = obj[property];
      return seen.has(value) ? false : seen.add(value);
    });
  };

  const handleSearch = (e) => {
    const searchFor = e.target.value.toLowerCase();
    const isRestrictedByArea =
      table?.area?.categories?.length && !isAdminMode(me, store?.slug);
    const allowedCategoryIds = isRestrictedByArea
      ? table.area.categories.map(({ id }) => id)
      : null;

    // 1. Text + type filter (only *ItemData objects; exclude categories / info entries)
    let baseMatches = (menuEntriesData || []).filter((data) => {
      if (!data?.searchString) return false;
      // Exclude category/info: they have type 'ItemCategory' or '*MenuEntry'
      if (data?.type === 'ItemCategory' || data?.type?.endsWith('MenuEntry'))
        return false;
      return data.searchString.toLowerCase().includes(searchFor);
    });

    // 2. Area restriction (raw menuEntries do NOT contain itemData list, so relate via itemEntry.id === item.item.id)
    if (isRestrictedByArea) {
      baseMatches = baseMatches.filter((item) => {
        const parentItemId = item?.item?.id; // itemData has parent item reference
        if (!parentItemId) return false;
        return (menuEntries || []).some((entry) => {
          if (entry.type !== 'ItemMenuEntry') return false;
          const categoryId = entry?.category?.id || entry?.categoryEntry?.id;
          if (!allowedCategoryIds.includes(categoryId)) return false;
          return entry?.itemEntry?.id === parentItemId;
        });
      });
    }

    // 3. Food filters
    const forbiddenIngredientIds = (foodIngredientsFilter || []).map(
      ({ id }) => id,
    );
    const forbiddenAllergenIds = (foodAllergensFilter || []).map(
      ({ id }) => id,
    );
    const requiredPreferenceIds = (foodPreferencesFilter || []).map(
      ({ id }) => id,
    );

    if (
      forbiddenIngredientIds.length ||
      forbiddenAllergenIds.length ||
      requiredPreferenceIds.length
    ) {
      baseMatches = baseMatches.filter((item) => {
        const ingredientsOk = (item.ingredients || []).every(
          ({ id }) => !forbiddenIngredientIds.includes(id),
        );
        if (!ingredientsOk) return false;
        const allergensOk = (item.allergens || []).every(
          ({ id }) => !forbiddenAllergenIds.includes(id),
        );
        if (!allergensOk) return false;
        const prefs = (item.preferences || []).map(({ id }) => id);
        return requiredPreferenceIds.every((id) => prefs.includes(id));
      });
    }

    const suggestions = baseMatches;

    const suggestionMap = new Map();

    suggestions.forEach((suggestion) => {
      const parentItemId = suggestion?.item?.id;
      const matchingMenuEntries = (menuEntries || []).filter(
        (entry) =>
          entry?.type === 'ItemMenuEntry' &&
          entry?.itemEntry?.id === parentItemId,
      );
      const categories = matchingMenuEntries
        .map((entry) => entry?.category)
        .filter(Boolean);
      if (!suggestionMap.has(suggestion.id)) {
        suggestionMap.set(suggestion.id, {
          ...suggestion,
          categories,
        });
      } else {
        const existing = suggestionMap.get(suggestion.id);
        existing.categories = [...existing.categories, ...categories];
      }
    });

    const mergedSuggestions = Array.from(suggestionMap.values());
    setSuggestions(
      mergedSuggestions.map((suggestion) => {
        return {
          ...suggestion,
          categories: filterUniqueObjects(suggestion?.categories, 'id'),
        };
      }),
    );

    clearTimeout(window.searchTimeout);
    window.searchTimeout = setTimeout(() => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'InitSearch',
          customerProfileId: me?.requester?.customerProfile?.id,
          searchText: searchFor,
        },
      });
    }, 1500);
  };

  const socketContext = useContext(SocketContext);
  const { switchLocale } = useContext(IntlContext);
  const intl = useIntl();
  const history = useHistory();

  const handleCanclelOrder = () => {
    const browserLocale = getBrowserLocale();
    setFoodPreferencesFilter(null);
    setFoodIngredientsFilter(null);
    setFoodAllergensFilter(null);
    setCheckout(null);
    setCart(null);
    setOrder(null);
    localStorage.removeItem('guestToken');
    socketContext.socket = null;
    createGuest({ locale: intl?.locale }, socketContext?.setToken).then(() => {
      fetchOnAuthenticated();
      fetchOrders();
    });
    switchLocale(browserLocale);
    history.push(`/store/${store?.slug}`);
    setSelfServiceTableSelectionModalData({
      showReducedModal: false,
    });
    if (store?.merchantProfile?.enableSelfServiceTableSelection) {
      setIsSelfServiceTableSelectionModalOpen(true);
    }
  };
  return (
    <ul className="nav navbar-nav navbar-nav-user float-right disable-dbl-tap-zoom rounded-bottom">
      {store && menuEntriesData && (
        <>
          {!isAdminMode(me, store?.slug) && !kiosk && (
            <NavItem
              className="p-0 d-flex align-items-center"
              onClick={() => setIsListOrdersModalOpen(true)}
            >
              <NavLink className={classnames('nav-link-search', 'mr-1')}>
                <Icon.ShoppingCart size={21} data-testid="ordersShortcut" />
              </NavLink>
            </NavItem>
          )}
          {table &&
            store?.merchantProfile?.posIntegration?.enableCallAWaiter &&
            store?.merchantProfile?.posIntegration?.dummyItemRefs?.length >
              0 && (
              <NavItem
                className="p-0 d-flex align-items-center"
                onClick={() => setIsCallWaiterModalOpen(true)}
              >
                <NavLink className={classnames('nav-link-search', 'mr-1')}>
                  <Icon.Bell size={21} id="filter" data-tour="filter" />
                </NavLink>
              </NavItem>
            )}
          {showCancelOrderButton && (
            <NavItem className="p-0 d-flex align-items-center">
              <NavLink
                className={classnames('nav-link-search', 'mr-1', {
                  'nav-link-filter': areAnyFiltersSet,
                })}
              >
                <Button
                  color="light"
                  className="px-1"
                  onClick={handleCanclelOrder}
                  size="sm"
                  outline={true}
                >
                  <FormattedMessage id="cancelOrderLabel" />
                </Button>
              </NavLink>
            </NavItem>
          )}
          <NavItem
            className="nav-search p-0 d-flex align-items-center"
            onClick={() => setIsSearchOpen(!isSearchOpen)}
          >
            <NavLink className={classnames('nav-link-search', 'mr-1')}>
              <Icon.Search size={21} data-tour="search" />
            </NavLink>
            <div
              className={classnames('search-input', {
                open: isSearchOpen,
                'd-none': !isSearchOpen,
              })}
            >
              <div className="search-input-icon">
                <Icon.Search size={17} className="primary" />
              </div>
              <FormattedMessage id="searchPlaceholder">
                {(placeholder) => (
                  <Autocomplete
                    className="form-control"
                    suggestions={suggestions}
                    filterKey="title"
                    filterHeaderKey="groupTitle"
                    grouped={true}
                    placeholder={placeholder}
                    autoFocus={true}
                    clearInput={isSearchOpen}
                    externalClick={() => {
                      setShowAppOverlay(false);
                      setIsSearchOpen(false);
                    }}
                    onChange={handleSearch}
                    onKeyDown={(e) => {
                      if (e.keyCode === 27 || e.keyCode === 13) {
                        setShowAppOverlay(false);
                        setIsSearchOpen(false);
                      }
                    }}
                    onSuggestionsShown={(userInput) => {
                      if (isSearchOpen) {
                        setShowAppOverlay(!!userInput);
                      }
                    }}
                    onSuggestionItemClick={() => setShowAppOverlay(false)}
                  />
                )}
              </FormattedMessage>
              <div className="search-input-close">
                <Icon.X
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAppOverlay(false);
                    setIsSearchOpen(false);
                  }}
                />
              </div>
            </div>
          </NavItem>

          <NavItem
            className="p-0 d-flex align-items-center"
            onClick={() => setIsSetFiltersModalOpen(true)}
          >
            <NavLink
              className={classnames('nav-link-search', 'mr-1', {
                'nav-link-filter': areAnyFiltersSet,
              })}
            >
              <Icon.Sliders
                size={21}
                id="filter"
                data-tour="filter"
                className={classnames({ primary: areAnyFiltersSet })}
              />
            </NavLink>
          </NavItem>
        </>
      )}

      <NavItem
        className="p-0 d-flex align-items-center"
        onClick={() => setIsMoreSettingsModalOpen(true)}
      >
        <NavLink className={classnames('nav-link-search', 'mr-1')}>
          <Icon.MoreVertical
            data-testid="moreSettingsButton"
            size={21}
            data-tour="more-settings"
          />
        </NavLink>
      </NavItem>
    </ul>
  );
};

const mapStateToProps = (state) => ({
  menuEntriesData: state.store.menuEntriesData,
  isSetFiltersModalOpen: state.modals.isSetFiltersModalOpen,
  foodAllergensFilter: state.me.foodAllergensFilter,
  foodPreferencesFilter: state.me.foodPreferencesFilter,
  foodIngredientsFilter: state.me.foodIngredientsFilter,
  pickupOrder: state.me.pickupOrder,
  menuEntries: state.store.menuEntries,
  kiosk: state.store.kiosk,
  table: state.store.table,
});

export default connect(mapStateToProps, {
  setIsCallWaiterModalOpen,
  setIsSetFiltersModalOpen,
  /*setIsPickupStatusModalOpen,*/
  setIsListOrdersModalOpen,
  setIsMoreSettingsModalOpen,
  setShowAppOverlay,
  setFoodAllergensFilter,
  setFoodIngredientsFilter,
  setFoodPreferencesFilter,
  setCheckout,
  setCart,
  setOrder,
  setIsSelfServiceTableSelectionModalOpen,
  setSelfServiceTableSelectionModalData,
})(NavbarUser);
